import { LogUserActivity } from '@/apis/users/requests'
import { buttonVariants } from '@/app/common/components/Button'
import { AppRoutePaths } from '@/routing/route_paths'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { LOG_TYPES } from '../../constants'
import FamilyWizardLayout from '../../FamilyWizardLayout'

export function TaxCommissionInfoPage() {
  const { t } = useTranslation()
  const application = useSelector(selectFamilyApplication)
  const navigate = useNavigate()
  const programSettings = useSelector(selectProgramSettings)

  const hasLoggedPageView = useRef(false);
  useEffect(() => {
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: 'Utah tax comission page',
      })
      hasLoggedPageView.current = true;
    }
  }, []) 

  return (
    <div>
      <FamilyWizardLayout>
        <FamilyWizardLayout.Header>
          <h1>{t('income_verification')}</h1>
        </FamilyWizardLayout.Header>
        <FamilyWizardLayout.Content>
          <p className="text-lg text-gray-800 font-medium mb-2">
            {t('utah_tax_commission')}
          </p>
          <p className="text-gray-600">{t('utah_tax_information', { 
            tax_year: programSettings.acceptable_income_year
          })}</p>

          {application.household_filed_federal_income === 'individually' && (
            <div className="bg-amber-50 px-4 py-4 rounded-md border border-amber-300 mt-4">
              <div className="text-amber-800 font-medium">{t("important")}</div>
              <p className="text-sm text-amber-800">
               {t("tax_commission_warning")}
              </p>
            </div>
          )}

          <Link
            className={buttonVariants({
              variant: 'text',
              size: 'text',
              className: 'h-12 mt-2',
            })}
            onClick={()=>{
              LogUserActivity({
                log_type: LOG_TYPES.VIEW_PAGE,
                suffix_text: 'Directions on how applicants can add authorization for ACE/UFA to access their tax info',
              })        
            }}
            target="_blank"
            to={"https://tax.utah.gov/media/utah-fits-all-creating-a-tap.pdf"}
          >
            {t("direction_authorization_for_ufa")}
          </Link>

          <FamilyWizardLayout.ActionBar className="flex-col">
            <a
              onClick={() => {
                navigate(
                  AppRoutePaths.family_application.income_verification
                    .tax_commission_verify_account
                )
              }}
              target="_blank"
              rel="noreferrer"
              className={buttonVariants({
                variant: 'primary',
                className: 'mt-4 w-full',
              })}
              href="https://tap.tax.utah.gov/TaxExpress"
            >
              {t('continue')}
            </a>
            <Link
              className={buttonVariants({
                variant: 'text',
                size: 'text',
                className: 'h-12',
              })}
              to={
                AppRoutePaths.family_application.income_verification
                  .document_instructions
              }
            >
             {t("skip_tax_commission")}
            </Link>
          </FamilyWizardLayout.ActionBar>
        </FamilyWizardLayout.Content>
      </FamilyWizardLayout>
    </div>
  )
}
